const GENDER_ICONS = {
    0: "neuter",
    1: "male",
    2: "female",
    3: "neuter",
    4: "transgender",
    5: "neuter",
}
export function getGenderIcon(sex: number): string {
    return GENDER_ICONS[sex] ?? GENDER_ICONS[0];
}